import React, { useState, useEffect } from "react";
import {
  appNameValidate,
  redircetUrlValidate,
  validateAppIcon,
  staticIpPrimaryValidate,
  staticIpSecondaryValidate
} from "../../utils/formValidate";
import DragAndDrop from "../../generic/dragAndDrop";
import { MYAPP_TITLE } from "../../../Containers/Client/MyApp/myAppConstents";
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import { color } from "highcharts";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: '#EBE9FF',
    color: '#4F4E70',
    fontSize: '12px',
    padding: '10px 12px',
    maxWidth: 280,
    borderRadius: 8,
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  },
  arrow: {
    color: '#EBE9FF',
  },
}));

const AppForm = (props) => {
  const {
    userId,
    fillCreateAppForm,
    createAppModal,
    submitCreateAppForm,
    createAppModalData,
    removeImage,
    updateCreateAppModalVal,
    setCreateAppModalData,
    editAppSubmit,
    createFormError,
    setCreateFormError,
  } = props;
  const [enableAssist, setEnableAssist] = useState(false);
  const [imgPicker, setImgPicker] = useState("");
  const classes = useStyles();
  const submitBtn = () => {
    if (createAppModal.title === MYAPP_TITLE.CREATE) {
      submitCreateAppForm();
    } else {
      editAppSubmit();
    }
  };

  let submutBtnHandler = () => {
    let validateAppName = appNameValidate(createAppModalData.appName);
    let validateRedirectUri = redircetUrlValidate(
      createAppModalData.redirectUri
    );
    let validatestaticIpPrimary = staticIpPrimaryValidate(
      createAppModalData.primaryIp
    );
    let validatestaticIpSecondary = staticIpSecondaryValidate(
      createAppModalData.secondaryIp,
      createAppModalData.primaryIp
    );
    if (validateAppName !== true) {
      setCreateFormError({
        ...createFormError,
        appName: validateAppName,
      });
    } else if (validateRedirectUri !== true) {
      setCreateFormError({
        ...createFormError,
        redirectUri: validateRedirectUri,
      });
    }else if (validatestaticIpPrimary !== true) {
      setCreateFormError({
        ...createFormError,
        primaryIp: validatestaticIpPrimary,
      });
    }else if (validatestaticIpSecondary !== true) {
      setCreateFormError({
        ...createFormError,
        secondaryIp: validatestaticIpSecondary,
      });
    } else {
      submitBtn();
    }
  };

  useEffect(() => {
    if (imgPicker.length > 0) {
      let validateIcon = validateAppIcon(imgPicker[0]);
      if (validateIcon === true) {
        setCreateAppModalData({
          ...createAppModalData,
          appImage: imgPicker[0],
          imgView: URL.createObjectURL(imgPicker[0]),
        });
        setCreateFormError({
          ...createFormError,
          appImage: "",
        });
      } else {
        setCreateFormError({
          ...createFormError,
          appImage: validateIcon,
        });
      }
    }
  }, [imgPicker]);

  return (
    <div id={createAppModal.isOpen ? "show_modal" : "hide_modal"}>
      <div className="modal_MyApp">
        <div className="modal_content_myApp createApp">
          <div>
            <div>
              <h2 className="head">{createAppModal.title}</h2>
            </div>
            <div className="createAppWrap mob_view">
              <div className="custom-col-12 align-center">
                <div className="custom-col-4 mob_view">
                  <label htmlFor="appName">App Name*</label>
                </div>
                <div className="custom-col-8">
                  <input
                    id="appName"
                    type="text"
                    name="appName"
                    value={createAppModalData.appName}
                    onChange={(e) => fillCreateAppForm(e)}
                  />
                  {createFormError.appName !== "" && (
                    <span className="form-err">{createFormError.appName}</span>
                  )}
                </div>
              </div>
              <div className="custom-col-12 align-center">
                <div className="custom-col-4">
                  <label htmlFor="nuvama_id">Nuvama Client ID*</label>
                </div>
                <div className="custom-col-8">
                  <input
                    id="nuvama_id"
                    type="text"
                    placeholder="client id"
                    name="clientId"
                    value={userId}
                  />
                </div>
              </div>
              <div className="custom-col-12 align-center">
                <div className="custom-col-4">
                  <label htmlFor="staticIP_Primary" style={{marginRight:'8px'}}>Static IP Primary*</label>
                  <Tooltip
                    title={
                      <>
                        <p>
                          To comply with SEBI’s latest circular on algorithmic trading, all users accessing
                          APIs must register a static IP address. Mandatory before October 1st.
                        </p>
                        <br/>
                        <br/>
                        <p>Contact your Internet Service Provider and request a Static IP.</p>
                      </>
                    }
                    arrow
                    placement="bottom"
                    classes={{
                      tooltip: classes.customTooltip,
                      arrow: classes.arrow,
                    }}
                  >
                    <i className="edel-icon-tooltip" style={{color:'#6374D4'}}></i>
                  </Tooltip>
                </div>
                <div className="custom-col-8">
                  <input
                    id="staticIP_Primary"
                    type="text"
                    name="primaryIp"
                    value={createAppModalData.primaryIp}
                    onChange={(e) => fillCreateAppForm(e)}
                    disabled={!createAppModal?.isIpEditable}
                  />
                  <span className="static_Ip_note">Please Note: The IP address can only be changed once in a calendar week.</span>
                   {createFormError.primaryIp !== "" && (
                    <span className="form-err">{createFormError.primaryIp}</span>
                  )}
                </div>
              </div>
              <div className="custom-col-12 align-center">
                <div className="custom-col-4 tooltip">
                  <label htmlFor="staticIP_Secondary" style={{marginRight:'8px'}}>Static IP Secondary</label>
                  <Tooltip
                    title={
                      <>
                        <p>
                         A backup or additional IP address that can handle requests if the primary fails or is overloaded.
                        </p>
                      </>
                    }
                    arrow
                    placement="bottom"
                    classes={{
                      tooltip: classes.customTooltip,
                      arrow: classes.arrow,
                    }}
                  >
                    <i className="edel-icon-tooltip" style={{color:'#6374D4'}}></i>
                  </Tooltip>
                </div>
                <div className="custom-col-8">
                  <input
                    id="staticIP_Secondary"
                    type="text"
                    name="secondaryIp"
                    value={createAppModalData.secondaryIp}
                    onChange={(e) => fillCreateAppForm(e)}
                    disabled={!createAppModal?.isIpEditable}
                  />
                   {createFormError.secondaryIp !== "" && (
                    <span className="form-err">{createFormError.secondaryIp}</span>
                  )}
                </div>
              </div>
              <div className="custom-col-12 align-center">
                <div className="custom-col-4">
                  <div className="redirectUrl">
                    <label htmlFor="redirectUrl">Redirect URL</label>
                    <span
                      className="txt_blue"
                      onClick={() => setEnableAssist(true)}
                    >
                      Enable Assist
                    </span>
                  </div>
                </div>
                <div className="custom-col-8">
                  <input
                    id="redirectUrl"
                    type="text"
                    name="redirectUri"
                    value={createAppModalData.redirectUri}
                    onChange={(e) => fillCreateAppForm(e)}
                  />
                  {createFormError.redirectUri !== "" && (
                    <span className="form-err">
                      {createFormError.redirectUri}
                    </span>
                  )}
                </div>
              </div>

              <div className="custom-col-12 align-center">
                <div className="custom-col-4">
                  <label htmlFor="appIcon">App Icon</label>
                  <span className="txt_grey">(Optional)</span>
                </div>
                <div className="custom-col-8">
                  {createAppModalData &&
                  createAppModalData.imgView.length > 0 ? (
                    <div className="imageViewer">
                      <div className="imageViewer_left">
                        <img
                          src={createAppModalData.imgView}
                          alt=" "
                          className="avatar"
                        />
                        <span className="ingSrc">
                          {createAppModalData.appImage.name}
                        </span>
                      </div>
                      <div>
                        <a href="#" onClick={removeImage}>
                          <span>Remove</span>
                          <i className="edel-icon-close"></i>
                        </a>
                      </div>
                    </div>
                  ) : (
                    <DragAndDrop onChange={setImgPicker} />
                  )}
                  {createFormError.appImage !== "" && (
                    <span className="form-err">{createFormError.appImage}</span>
                  )}
                </div>
              </div>
              {/* <div className="text">
                  <p>An amount of <span>₹2,000</span> will be charged to activate this app</p>
                </div>  */}

              <div className="display-flex w-100 desktopAppFormBtn">
                <button
                  onClick={() => updateCreateAppModalVal(false, "", "")}
                  className="custom-btn border-btn w-30"
                >
                  Cancel
                </button>
                <button
                  className="custom-btn block-btn w-70"
                  onClick={submutBtnHandler}
                >
                  {createAppModal.title === "Create New App"
                    ? "Create"
                    : "Save"}
                </button>
              </div>
            </div>
            <div className="mob_footer">
              <div className="mobAppFormBtn">
                <button
                  onClick={() => updateCreateAppModalVal(false, "", "")}
                  className="custom-btn border-btn "
                >
                  Cancel
                </button>
                <button
                  className="custom-btn block-btn "
                  onClick={submutBtnHandler}
                >
                  {createAppModal.title === "Create New App"
                    ? "Create"
                    : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id={enableAssist ? "show_modal" : "hide_modal"}>
        <div className="assistModal">
          <div className="assistModal_container">
            <div className="assistModal_head">
              <p>Redirect URL</p>
              <span onClick={() => setEnableAssist(false)}>
                {" "}
                <i className="edel-icon-close"></i>
              </span>
            </div>
            <div className="assistModal_content">
              <p>
                Register a redirect_url with us when you create an App to
                receive the request_id. For personal desktop apps, you can run a
                local web server and use the default{" "}
                <a target="_blank">https://127.0.0.1/</a> as the redirect_url's'
                host.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppForm;
